export const localizeItemCount = (localize, token, itemCount) => 
  (isFinite(itemCount) ? localize(token, { count: itemCount }) : '');
